module.exports = __webpack_public_path__ + "img/bull-and-bear.2bd616ea.png";